import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCheck } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "./../Pages/Config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserReviewInfo from "../components/UserReviewInfo";
import Swal from "sweetalert2";

export default function SettingUser() {
  const [sessionuser, setUser] = useState(null);
  const [data, setUserdata] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState([]);

  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [newImage, setNewImage] = useState(null);

  const userId = Cookies.get("user_id");

  const fetchUserData = () => {
    const userid = Cookies.get("user_id");
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userid}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          const userData = res.data.data[0];
          setUserdata(res.data.data);
          setUser(userData);
          //  console.log("userdata", res.data.data);
          setName(res.data.data.name);
          setImage(`${BASE_URL}/${res.data.data.image}`);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  };

  useEffect(() => {
    // Call immediately once
    fetchUserData();

    const interval = setInterval(() => {
      fetchUserData();
    }, 120000); // 2 minutes

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_review.php?id=${userId}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          setUser(res.data.user);
          setRating(res.data.rating_stats);
          setReviews(res.data.reviews);
        } else {
          console.error("User or reviews not found");
        }
      })
      .catch((error) => console.error("API error:", error));
  }, [userId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(URL.createObjectURL(file));
    }
  };
  const handleSave = async () => {
    try {
      // Trim spaces at start/end
      const trimmedName = name.trim();

      // Check if empty
      if (!trimmedName) {
        toast.error("Name is required!");
        return;
      }

      // Check if contains spaces
      if (/\s/.test(trimmedName)) {
        toast.error("Name cannot contain spaces!");
        return;
      }

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("name", trimmedName);

      const fileInput = document.getElementById("fileInput");
      if (fileInput?.files[0]) {
        formData.append("image", fileInput.files[0]);
      }

      const res = await axios.post(
        `${BASE_URL}/update_user_name.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      // console.log(res);

      if (res.data.success) {
        toast.success("Profile updated!");

        setIsEditing(false);
        setNewImage(null);
        setImage(res.data.image ? `${BASE_URL}/${res.data.image}` : image);
        setUser((prev) => ({ ...prev, name: trimmedName }));
        fetchUserData();

        window.location.reload();
      } else {
        toast.error("Update failed");

        fetchUserData();
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleCancel = () => {
    setIsEditing(false);

    setName(data.name);
    setNewImage(null);
    fetchUserData();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    return `${days[date.getDay()]} ${String(date.getDate()).padStart(2, "0")} ${
      months[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  // Add this function
  const handleDeleteImage = async () => {
    const userId = Cookies.get("user_id"); // get user ID from cookie

    Swal.fire({
      title: "Are you sure?",
      text: "Your profile image will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(
            `${BASE_URL}/delete_user_image.php?user_id=${userId}`,
          );
          console.log(res);

          if (res.data.success) {
            Swal.fire(
              "Deleted!",
              "Your profile image has been deleted.",
              "success",
            );
            setImage(""); // remove current image
            setNewImage(null);
            fetchUserData(); // refresh user data
          } else {
            Swal.fire("Failed!", res.data.message, "error");
          }
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error!", "Something went wrong!", "error");
        }
      }
    });
  };

  const [userChargesTotal, setUserChargesTotal] = useState(0);

  useEffect(() => {
    const updateNotifications = async () => {
      const user_id = Cookies.get("user_id");

      try {
        const res = await fetch(
          `${BASE_URL}/user_charges_count.php?user_id=${user_id}&t=${Date.now()}`,
          { cache: "no-store" },
        );

        const data = await res.json();
        // console.log("Charges Total:", data);

        if (data.success) {
          setUserChargesTotal(data.unpaid_total || 0); // ✅ Update state
          //  console.log("Charges Unpaid Amount:", data.unpaid_total);
        } else {
          //    console.log("Error:", data.message);
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    updateNotifications();
  }, []);

  const [verifyingEmail, setVerifyingEmail] = useState(false);

  const verifyEmail = async (email) => {
    setVerifyingEmail(true); // Start loader

    console.log(email);
    try {
      const response = await axios.post(`${BASE_URL}/verify_email.php`, {
        email: email, // use actual email
      });

      console.log(response);
      const result = response.data;

      if (result.success) {
        toast.success("Verification email sent ! Check Email.");
        setVerifyingEmail(true);
      } else {
        toast.error("Failed: " + result.message);
        setVerifyingEmail(false);
      }
    } catch (error) {
      toast.error("Error: " + (error.response?.data?.message || error.message));
    }
  };

  useEffect(() => {
    // Run only if data exists

    //  console.log(verifyingEmail);
    if (!data) return;
    if (!verifyingEmail) return;

    const interval = setInterval(() => {
      console.log("verified:", data.is_verified);

      fetchUserData();

      if (data.is_verified == 1) {
        setVerifyingEmail(false);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [verifyingEmail, data]);

  return (
    <>
      <div className="user-info">
        <div className="img">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexDirection: "column",
            }}
          >
            <div style={{ position: "relative", display: "inline-block" }}>
              <label htmlFor="fileInput">
                {newImage || image ? (
                  <img
                    src={newImage || image}
                    alt="User"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      cursor: isEditing ? "pointer" : "default",
                      border: isEditing ? "2px dashed #aaa" : "none",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                      const fallback =
                        document.getElementById("fallbackInitial");
                      if (fallback) fallback.style.display = "flex";
                    }}
                  />
                ) : null}

                <div
                  id="fallbackInitial"
                  style={{
                    display: newImage || image ? "none" : "flex",
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#ccc",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "24px",
                    color: "#fff",
                    textTransform: "uppercase",
                    cursor: isEditing ? "pointer" : "default",
                    border: isEditing ? "2px dashed #aaa" : "none",
                  }}
                >
                  {name?.[0] || "F"}
                </div>
              </label>

              {isEditing && image && (
                <button
                  onClick={handleDeleteImage}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    background: "red",
                    border: "none",
                    borderRadius: "50%",
                    color: "white",
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Delete Image"
                >
                  ✖
                </button>
              )}

              {isEditing && (
                <input
                  id="fileInput"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              )}
            </div>

            <div>
              <AnimatePresence mode="wait">
                {isEditing ? (
                  <motion.div
                    key="input"
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      style={{
                        fontSize: "18px",
                        padding: "5px 10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    />
                    <button
                      onClick={handleSave}
                      style={{
                        border: "none",
                        background: "none",
                        color: "green",
                        cursor: "pointer",
                      }}
                      title="Save"
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <button
                      onClick={handleCancel}
                      style={{
                        border: "none",
                        background: "none",
                        color: "red",
                        cursor: "pointer",
                        fontSize: "18px",
                      }}
                      title="Cancel"
                    >
                      ✖️
                    </button>
                  </motion.div>
                ) : (
                  <motion.div
                    key="text"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 10 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <br />
                    <b style={{ fontSize: "18px" }}>SALAM, {name}</b>
                    <button
                      onClick={() => setIsEditing(true)}
                      style={{
                        border: "none",
                        background: "none",
                        color: "green",
                        cursor: "pointer",
                      }}
                      title="Edit"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>

          <UserReviewInfo userId={data?.id} />
        </div>

        <div className="info">
          <ul>
            <li>
              <div className="info-title">
                <b>Member number</b>
              </div>
              <p>{data?.id || "Loading..."}</p>
            </li>
            <li>
              <div className="info-title">
                <b>User Name</b>
              </div>
              <p>
                {!data ? "Loading..." : data.name ? data.name : "Not Found"}
              </p>
            </li>
            <li>
              <div className="info-title">
                <b>Balance Charges</b>
              </div>
              <p>
                {userChargesTotal != null
                  ? `${userChargesTotal} SAR`
                  : "Loading..."}
              </p>
            </li>
            <li>
              <div
                className="info-title"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <b>Email</b>

                {data.is_verified === "1" || data.is_verified === 1 ? (
                  <span
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      fontSize: "13px",
                    }}
                  >
                    ✔ Verified
                  </span>
                ) : (
                  <>
                    {verifyingEmail ? (
                      <div className="make-public-spinner"></div>
                    ) : (
                      <p
                        onClick={() => verifyEmail(data.email)}
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          textDecoration: "underline",
                        }}
                      >
                        Resend Email Verification
                      </p>
                    )}
                  </>
                )}
              </div>
              <p>
                {!data ? "Loading..." : data.email ? data.email : "Not Found"}
              </p>
            </li>

            <li>
              <div className="info-title">
                <b>Phones</b>
              </div>
              <p>
                + {!data ? "" : data.country_code ? data.country_code : ""}{" "}
                {!data
                  ? "Loading..."
                  : data.phone_num
                    ? data.phone_num
                    : "Not Found"}
              </p>
            </li>
            <li>
              <div className="info-title">
                <b>Member since</b>
              </div>
              <p>{data ? formatDate(data.created_date) : "Loading..."}</p>
            </li>
            <li style={{ borderBottom: "none" }}>
              <div className="info-title">
                <b>Subscription</b>
              </div>
              <p
                style={{
                  color:
                    data?.membership_type === "Gold"
                      ? "gold"
                      : data?.membership_type === "silver"
                        ? "silver"
                        : "black",
                  fontWeight: "800",
                }}
              >
                {data?.membership_type || "Loading..."}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
